<template>
    <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="680">

      <v-card>

        <CardUpdatableHeader :row="row" :level="level">
          <template slot="subheader">
            <span>pour le client {{level.customer.cus_name}} ({{level.customer.cus_code}})</span>
         </template>
        </CardUpdatableHeader>

         <v-form v-model="isFormValid">

            <v-card-text>
               <v-container>
                  <v-row v-if="level.dialogValues.form_create">
                     <h4>{{ $t('subtitles.ldc_section_platform') }}</h4>

                     <v-col cols="12">
                        <ddoSelectPlatform :callbacks="PLFcallbacks" ref="mySelectPLF" :options="PLFoptions"/>
                     </v-col>

                  </v-row>

                  <v-row v-else>
                  <v-col cols="12">
                     <h4>{{ $t('subtitles.ldc_section_platform') }}</h4>
                     <v-chip>{{ row.plf_name }}</v-chip>
                  </v-col>
                  </v-row>

                  <v-row v-if="PLFdialogOptions.plf_is_dynamic">
                  <v-col cols="12">
                     <v-text-field v-model="row.xxx_dyn_connector_name" :disabled="level.dialogValues.form_disabled" :label="$t('texts.xxx_dyn_connector_name')" :rules="level.dialogOptions.codeRules" :hint="$t('hints.xxx_dyn_connector_name')" :persistent-hint="level.dialogValues.form_create">
                     </v-text-field>
                  </v-col>
                  </v-row>

                  <v-row v-if="PLFdialogOptions.plf_is_auth">
                  <v-col cols="12">
                     <h4>{{ $t('subtitles.ldc_section_ou') }}</h4>
                  </v-col>
                  <v-col cols="12">
                     <v-text-field v-model="row.xxx_ad_org_unit" :disabled="level.dialogValues.form_disabled" outlined :label="$t('texts._xxx_ad_org_unit')" :rules="[rules.minimalPathRules(level.dialogValues.plf_minimal_root_path)]" required :hint="$t('hints.xxx_ad_org_unit')" :persistent-hint="level.dialogValues.form_create">
                     </v-text-field>
                  </v-col>
                  </v-row>

                  <v-row v-if="PLFdialogOptions.plf_is_auth && PLFdialogOptions.plf_is_dynamic">
                  <v-col cols="12">
                     <h4>{{ $t('subtitles.ldc_section_dynamic') }}</h4>
                  </v-col>
                  <v-col cols="12" sm="6">
                     <v-text-field v-model="row.xxx_dyn_ldap_uri" :disabled="level.dialogValues.form_disabled" :label="$t('texts._xxx_dyn_ldap_uri')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints.xxx_dyn_ldap_uri')" :persistent-hint="level.dialogValues.form_create">
                     </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                     <v-text-field v-model="row.xxx_dyn_ldap_basedn" :disabled="level.dialogValues.form_disabled" :label="$t('texts._xxx_dyn_ldap_basedn')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints.xxx_dyn_ldap_basedn')" :persistent-hint="level.dialogValues.form_create">
                     </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                     <v-text-field v-model="row.xxx_dyn_ldap_bind_login" :disabled="level.dialogValues.form_disabled" :label="$t('texts._xxx_dyn_ldap_bind_login')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints.xxx_dyn_ldap_bind_login')" :persistent-hint="level.dialogValues.form_create">
                     </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                     <v-text-field
                        v-model="row.xxx_dyn_ldap_bind_password"
                        :disabled="level.dialogValues.form_disabled"
                        :label="$t('texts._xxx_dyn_ldap_bind_password')"
                        :rules="level.dialogOptions.codeRules"
                        required
                        :hint="$t('hints.xxx_dyn_ldap_bind_password')" 
                        :persistent-hint="level.dialogValues.form_create"
                        name="xxx_dyn_ldap_bind_password"
                        :type="showBindPassword ? 'text' : 'password'"
                        :append-icon="showBindPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showBindPassword = !showBindPassword"
                     >
                     </v-text-field>
                  </v-col>
                  </v-row>

                  <v-row v-if="!level.dialogValues.form_create && PLFdialogOptions.plf_is_auth && !PLFdialogOptions.plf_is_dynamic">
                  <v-col cols="12">
                     <h4>{{ $t('subtitles.ldc_section_auth') }}</h4>
                  </v-col>

                  <v-col cols="12" sm="6">
                     <v-text-field v-model="row.plf_ws_url_base" disabled :label="$t('texts.plf_ws_url_base')" />
                  </v-col>

                  <v-col cols="12" sm="6">
                     <v-text-field v-model="row.plf_domain_radix" disabled :label="$t('texts.plf_domain_radix')" />
                  </v-col>
                  </v-row>

                  <v-col v-if="!level.dialogValues.form_create" cols="12">
                     <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row._create,'long') }}<br/>
                     <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row._update,'long') }}
                  </v-col>
               </v-container>
               <small>*{{ $t('texts.requiredfield') }}</small>
            </v-card-text>

         </v-form>

         <CardUpdatableFooter :row="row" :level="level"/>

      </v-card>
    </v-dialog>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import ddoSelectPlatform from '@/components/ddoSelectPlatform.vue';

export default {
   name: 'CardUpdatableLdapConnector',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      ddoSelectPlatform,
      CardUpdatableHeader,
      CardUpdatableFooter
   },
   data: function () {
      return {
         boolFormValid: true,
         showBindPassword: false,
         PLFcallbacks: {},
         PLFoptions: {
            initial: null,
            required: true,
            disabled: true,
            multiple: false,
            clearable: false,
            item_text: "plf_name",
            item_value: "plf_pk",
            item_disabled: "",
            hide_selected: true,
            label: i18n.t('texts.platform'),
         },
         PLFdialogOptions: {
            cus_code: null,
            cus_name: null,
            plf_is_auth: false,
            plf_is_dynamic: false,
            plf_exchangelike: false,
            plf_citrixlike: false,
            plf_ws_url_base: null,
            plf_domain_radix: null,
         },
         rules: {
            minimalPathRules(minimalString) {
               return v => v.startsWith(minimalString) || i18n.t('texts._minimal_root_path');
            }
         }
      }
   },

   computed: {

      isFormValid: {
         get: function() {
            return this.boolFormValid;
         },
         set: function(newValue) {
            this.boolFormValid = newValue;
            if ( this.level.dialogValues.form_create==true ) {
               this.$emit('change_dialogValues',this.level.level,'disable_create',!newValue);
            }
            if ( this.level.dialogValues.form_update==true ) {
               this.$emit('change_dialogValues',this.level.level,'disable_update',!newValue);
            }
         }
      },

   },

   created() {
   },

   async mounted() {
      this.PLFcallbacks.refresh_rows = this.build_select_plf;
      this.PLFcallbacks.change = this.change;
   },

   methods: {

      async refresh_select_plf(key=null) {
         await this.$refs.mySelectPLF.refresh_rows(key);
      },

      async build_select_plf(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'ldapplatform');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async change(value,item=null) {
         //console.log('In form, change plf select, value='+value);
         //console.log('In form, change plf select, item='+JSON.stringify(item));
         if ( item!=null) {
            this.PLFdialogOptions.plf_name         = item.plf_name;
            this.PLFdialogOptions.plf_is_auth      = item.plf_is_auth;
            this.PLFdialogOptions.plf_is_dynamic   = item.plf_is_dynamic;
            this.PLFdialogOptions.plf_exchangelike = ( item.plf_exchangelike==1 ? true : false);
            this.PLFdialogOptions.plf_citrixlike   = ( item.plf_citrixlike==1 ? true : false);
            this.PLFdialogOptions.plf_smtplike     = ( item.plf_smtplike==1 ? true : false);
            this.PLFdialogOptions.plf_ws_url_base  = item.plf_ws_url_base;
            this.PLFdialogOptions.plf_domain_radix = item.plf_domain_radix;
            console.log('In CardUpdatableLdapConnector.change, PLFdialogOptions='+JSON.stringify(this.PLFdialogOptions));
            this.level.row.plf_pk = item.plf_pk;
            console.log('In CardUpdatableLdapConnector.change, row='+JSON.stringify(this.level.row));
         } else {
         console.log('In CardUpdatableLdapConnector.form, change plf select, NO CHANGE!, value='+value);
         }
      },

   },
   
}
</script>